// Generated from SVG to Code Figma Plugin

export const BaseLineUsed = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.5711 3.24735C11.6921 2.88807 12.3094 2.88807 12.4305 3.24735C12.9396 4.7581 13.9113 7.11035 15.4008 8.59981C16.855 10.0541 19.1318 11.0148 20.6448 11.5332C21.0093 11.6581 21.003 12.3151 20.637 12.4356C19.1615 12.9215 16.9505 13.85 15.4008 15.3998C13.8259 16.9747 12.8924 19.2325 12.4132 20.7073C12.2954 21.0699 11.6647 21.083 11.5391 20.723C11.0024 19.1844 10.0069 16.8059 8.60078 15.3998C7.16464 13.9637 4.71408 12.9558 3.1801 12.4277C2.82542 12.3056 2.82941 11.71 3.18523 11.5913C4.69289 11.0882 7.09043 10.1102 8.60078 8.5998C10.0902 7.11035 11.062 4.7581 11.5711 3.24735Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
